import { Message, AgentChat } from "@budibase/types"

export interface LLMPromptResponse {
  message: string
  tokensUsed: number
}

export interface LLMFullResponse {
  messages: Message[]
  tokensUsed: number
}

export interface LLMStreamChunk {
  type:
    | "content"
    | "tool_call_start"
    | "tool_call_result"
    | "done"
    | "error"
    | "chat_saved"
  content?: string
  toolCall?: {
    id: string
    name: string
    arguments: string
  }
  toolResult?: {
    id: string
    result: string
    error?: string
  }
  messages?: Message[]
  chat?: AgentChat
  tokensUsed?: number
}
